export const SECTION_TITLE = 'sectionTitle';
export const DESCRIPTION = 'description';
export const CHANNEL = 'channel';
export const URL = 'url';
export const PLATFORM = 'platform';
export const ENABLE_CHAT = 'enableChat';
export const CTA = 'cta';
